import LandingClasses from "../landing/Landing.module.css"
import DepartmentsClasses from "../Departments/Departments.module.css"
import OurWorkClasses from "../OurWork/OurWork.module.css"
import MapClasses from "../Map/Map.module.css"
import FactsNFiguresClasses from "../FactsNFigures/FactsNFigures.module.css"
import FooterClasses from "../Footer/Footer.module.css"
import GivingClasses from "../Giving/Giving.module.css"

//This folder Gathers container classes from various components and exports them together
// It helps in the functionality of scrolling to the component

const ContainerClasses = {
    LandingContainer: LandingClasses.container,
    DepartmentsContainer: DepartmentsClasses.container,
    OurWorkContainer: OurWorkClasses.container,
    MapContainer: MapClasses.container,
    FactsNFIguresContainer: FactsNFiguresClasses.bigNumber,
    FooterContainer: FooterClasses.container,
    GivingContainer: GivingClasses.container,
}
export default ContainerClasses;